export default {
    "1": { id: "1", title: "cash" },
    "2": { id: "2", title: "cashless" },
}
